import React, { useState } from 'react'
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, withStyles } from '@material-ui/core/styles'
import { Link, Breadcrumbs, Typography, Stepper, Step, StepLabel, StepConnector } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom'
import CheckIcon from '@material-ui/icons/Check';

import { useSelector } from 'react-redux';

import { PropertySteps, PropertyStepNames } from '../constants/config'

const useStyles = makeStyles((theme) => ({
    wrap: {
        width: '100%',
        padding: '5px',
        marginTop: '20px',
        marginBottom: '20px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    root: {
      padding: '15px'
    },
    horizontal: {
      width: '45px',
      paddingLeft: '4px',
      paddingRight: '4px',
    },
    labelContainer: {
    }
}));

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: '#784af4',
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  completed: {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? <CheckIcon className={classes.completed} /> : <div className={classes.circle} />}
    </div>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
};

// 財産ステップ
function PropertyStep(props){
    const classes = useStyles();

    const activeList = {
      'money': false,
      'deposit': false,
      'land': false,
      'building': false,
      'apartment': false,
      'stock': false,
      'fund': false,
      'bond': false,
      'automobile': false,
      'other': false
    };

    const checkList = {
      'money': false,
      'deposit': false,
      'land': false,
      'building': false,
      'apartment': false,
      'stock': false,
      'fund': false,
      'bond': false,
      'automobile': false,
      'other': false
    };

    const money = useSelector(state => state.money.money);
    if(props.nowPage == 'money'){
      activeList['money'] = true;
    }
    if(money.length && props.nowPage != 'money'){
      checkList['money'] = true;
    }else{
      checkList['money'] = false;
    }
    const deposit = useSelector(state => state.deposit.deposit);
    if(props.nowPage == 'deposit'){
      activeList['deposit'] = true;
    }
    if(deposit.length && props.nowPage != 'deposit'){
      checkList['deposit'] = true;
    }else{
      checkList['deposit'] = false;
    }
    const land = useSelector(state => state.land.land);
    if(props.nowPage == 'land'){
      activeList['land'] = true;
    }
    if(land.length && props.nowPage != 'land'){
      checkList['land'] = true;
    }else{
      checkList['land'] = false;
    }
    const building = useSelector(state => state.building.building);
    if(props.nowPage == 'building'){
      activeList['building'] = true;
    }
    if(building.length && props.nowPage != 'building'){
      checkList['building'] = true;
    }else{
      checkList['building'] = false;
    }
    const apartment = useSelector(state => state.apartment.apartment);
    if(props.nowPage == 'apartment'){
      activeList['apartment'] = true;
    }
    if(apartment.length && props.nowPage != 'apartment'){
      checkList['apartment'] = true;
    }else{
      checkList['apartment'] = false;
    }
    const stock = useSelector(state => state.stock.stock);
    if(props.nowPage == 'stock'){
      activeList['stock'] = true;
    }
    if(stock.length && props.nowPage != 'stock'){
      checkList['stock'] = true;
    }else{
      checkList['stock'] = false;
    }
    const fund = useSelector(state => state.fund.fund);
    if(props.nowPage == 'fund'){
      activeList['fund'] = true;
    }
    if(fund.length && props.nowPage != 'fund'){
      checkList['fund'] = true;
    }else{
      checkList['fund'] = false;
    }
    const bond = useSelector(state => state.bond.bond);
    if(props.nowPage == 'bond'){
      activeList['bond'] = true;
    }
    if(bond.length && props.nowPage != 'bond'){
      checkList['bond'] = true;
    }else{
      checkList['bond'] = false;
    }
    const automobile = useSelector(state => state.automobile.automobile);
    if(props.nowPage == 'automobile'){
      activeList['automobile'] = true;
    }
    if(automobile.length && props.nowPage != 'automobile'){
      checkList['automobile'] = true;
    }else{
      checkList['automobile'] = false;
    }
    const other = useSelector(state => state.other.other);
    if(props.nowPage == 'other'){
      activeList['other'] = true;
    }
    if(other.length && props.nowPage != 'other'){
      checkList['other'] = true;
    }else{
      checkList['other'] = false;
    }

    const [activeStep, setActiveStep] = useState(props.activeStep);

    return(
        <div id="page_top" className={classes.wrap}>
            <Stepper classes={{ root: classes.root }} alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
                {
                    PropertySteps.map((label, index) => {
                        return (
                            <Step classes={{ horizontal: classes.horizontal }} key={label} active={activeList[PropertyStepNames[index]]} completed={checkList[PropertyStepNames[index]]}>
                                <StepLabel classes={{ labelContainer: classes.labelContainer }}StepIconComponent={QontoStepIcon}>{label}</StepLabel>
                            </Step>
                        );
                    })
                }
            </Stepper>
        </div>
    );
}

export default PropertyStep
